import { render, staticRenderFns } from "./ProjectsReports.vue?vue&type=template&id=7afb3bcb&scoped=true&"
import script from "./ProjectsReports.vue?vue&type=script&lang=js&"
export * from "./ProjectsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb3bcb",
  null
  
)

export default component.exports